module.exports = __webpack_public_path__ + "static/media/Proxima-Nova-Regular.920c71d3.woff2";